export const MARK_VIEWBOX = { x: 1630.79, y: 687.59, width: 674.77, height: 1364.59 };
export const MARK_CENTER = {
  x: MARK_VIEWBOX.x + MARK_VIEWBOX.width / 2,
  y: MARK_VIEWBOX.y + MARK_VIEWBOX.height / 2,
};
export const MARK_POLYGONS = [
  '1786.88 1992.72 1630.79 2052.18 2033.65 763.16 2153.98 729.74 1786.88 1992.72',
  '1982.28 1918.29 1830.99 1975.92 2188.09 720.26 2305.56 687.59 1982.28 1918.29',
];

export const MARK_VIEWBOX_SPACE = MARK_VIEWBOX.height;
export const MARK_VIEWBOX_MIN = {
  x: MARK_CENTER.x - MARK_VIEWBOX_SPACE / 2,
  y: MARK_CENTER.y - MARK_VIEWBOX_SPACE / 2,
};
export const MARK_VIEWBOX_ATTR = `${MARK_VIEWBOX_MIN.x} ${MARK_VIEWBOX_MIN.y} ${MARK_VIEWBOX_SPACE} ${MARK_VIEWBOX_SPACE}`;

export interface CaseInk {
  /** The plate colour: the mark overlay, halftone, offset shadows and CTA shadow */
  color: string;
  /** The opposite plate, for the anaglyph offset */
  counter: string;
}

const LOGO_CYAN = 'var(--color-logo-cyan)';
const LOGO_RED = 'var(--color-logo-red)';

export const CASE_INKS: CaseInk[] = [
  { color: LOGO_CYAN, counter: LOGO_RED },
  { color: LOGO_RED, counter: LOGO_CYAN },
];

/**
 * @param index - Zero-based case position
 * @returns The ink for this case, alternating the logo's cyan and red
 */
export function caseInk(index: number): CaseInk {
  return CASE_INKS[index % CASE_INKS.length];
}
